(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pmt-texte-voir-plus"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pmt-read-more')) {
    class PmtReadMore extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-rm-content]');
        this.button = this.querySelector('[data-rm-toggle]');
        this.label = this.querySelector('[data-rm-label]');
        if (!this.content || !this.button) return;

        this.expanded = false;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.onClick = () => (this.expanded ? this.collapse() : this.expand());
        // Accessibilité : si on navigue au clavier vers un lien caché, on déplie
        this.onFocusIn = () => { if (!this.expanded && !this.button.hidden) this.expand(); };
        this.onResize = () => { if (!this.expanded) this.checkOverflow(); };

        this.button.addEventListener('click', this.onClick);
        this.content.addEventListener('focusin', this.onFocusIn);
        window.addEventListener('resize', this.onResize, { passive: true });

        this.checkOverflow();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
      }

      // Cache le bouton si le texte est assez court pour tenir dans les lignes visibles
      checkOverflow() {
        this.content.classList.add('is-collapsed');
        const fits = this.content.scrollHeight <= this.content.clientHeight + 2;
        this.button.hidden = fits;
        this.content.classList.toggle('is-collapsed', !fits);
      }

      setState() {
        this.button.setAttribute('aria-expanded', String(this.expanded));
        this.label.textContent = this.expanded
          ? this.button.dataset.textLess
          : this.button.dataset.textMore;
      }

      expand() {
        const c = this.content;
        this.expanded = true;
        this.setState();

        if (this.reduceMotion) {
          c.classList.remove('is-collapsed');
          c.style.maxHeight = 'none';
          return;
        }

        c.style.maxHeight = c.offsetHeight + 'px';
        c.classList.remove('is-collapsed');
        void c.offsetHeight; // force le recalcul pour lancer la transition
        c.style.maxHeight = c.scrollHeight + 'px';

        const done = (e) => {
          if (e.propertyName !== 'max-height') return;
          if (this.expanded) c.style.maxHeight = 'none';
          c.removeEventListener('transitionend', done);
        };
        c.addEventListener('transitionend', done);
      }

      collapse() {
        const c = this.content;
        this.expanded = false;
        this.setState();

        c.style.maxHeight = c.scrollHeight + 'px';
        void c.offsetHeight;
        c.classList.add('is-collapsed');
        c.style.maxHeight = '';

        // Si le haut de la section est sorti de l'écran, on y remonte
        if (this.getBoundingClientRect().top < 0) {
          this.scrollIntoView({ behavior: this.reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }
      }
    }
    customElements.define('pmt-read-more', PmtReadMore);
  }

  } catch(e) { console.error(e); }
})();
})();
